if (!customElements.get('product-form')) {
	customElements.define('product-form', class AddToCart extends HTMLElement {
		constructor() {
			super();
			this.form = this.querySelector('form');
			this.addButtons = this.querySelectorAll('button[name="add"]');

			this.fileInput = this.querySelector('.upload-input');
			this.textInput = this.querySelector('#engraving-text');
			this.errorContainer = this.querySelector('.js-general-error') ||
				this.querySelector('.validation-error-msg') ||
				this.querySelector('.upload-error') ||
				this.querySelector('.global-error-container');

			this.errorMessageText = this.dataset.contentError;

			if (this.form) {
				this.form.addEventListener('submit', this.formSubmit.bind(this));
				this.form.addEventListener('change', this.clearErrorMessage.bind(this));

				if (this.fileInput) {
					this.fileInput.addEventListener('change', this.handleFileSelect.bind(this));
				}
				if (this.textInput) {
					this.textInput.addEventListener('input', () => {
						if (this.textInput.value.trim().length > 0) this.clearErrorMessage();
					});
				}
			}
		}

		handleFileSelect(evt) {
			const files = evt.target.files;
			if (files.length > 2) {
				this.showCustomError("You can upload a maximum of 2 images.");
				evt.target.value = '';
			} else {
				this.clearErrorMessage();
			}
		}

		validateEngravingRequirements() {
			const engravingPopup = this.closest('.engraving-popup');
			if (!engravingPopup) return true;

			const hasText = this.textInput && this.textInput.value.trim().length > 0;
			const hasFile = this.fileInput && this.fileInput.files.length > 0;

			if (!hasText && !hasFile) {
				throw new Error(this.errorMessageText);
			}
			return true;
		}

		clearErrorMessage() {
			if (this.errorContainer) {
				this.errorContainer.innerHTML = '';
				this.errorContainer.style.display = 'none';
			}
		}

		showCustomError(msg) {
			this.clearErrorMessage();
			if (this.errorContainer) {
				this.errorContainer.style.display = 'block';
				if (this.errorContainer.classList.contains('js-general-error')) {
					this.errorContainer.innerText = msg;
				} else {
					let errorBlock = document.createElement('p');
					errorBlock.classList.add('product-error');
					errorBlock.style.color = '#d32f2f';
					errorBlock.innerText = msg;
					this.errorContainer.appendChild(errorBlock);
				}
			} else {
				alert(msg);
			}
		}

		isInProduction(variantId) {
			const ids = (this.dataset.productionVariants || '').split(',');
			return Boolean(variantId) && ids.includes(String(variantId));
		}

		async formSubmit(evt) {
			evt.preventDefault();
			this.clearErrorMessage();

			try {
				this.validateEngravingRequirements();
				this.toggleLoadingState(true);

				const engravingPopup = this.closest('.engraving-popup');
				let formData = new FormData();
				let configBody;

				if (engravingPopup) {
					const mainIdInput = this.form.querySelector('.js-main-id');
					if (!mainIdInput || !mainIdInput.value) throw new Error("Main product ID not found.");

					formData.append('items[0][id]', mainIdInput.value);
					formData.append('items[0][quantity]', 1);

					const selectedRadio = this.form.querySelector('input[name="engravingCost"]:checked');
					const engravingIdInput = selectedRadio ? selectedRadio.closest('.radio-box').querySelector('input[name="engraving_id"]') : null;

					if (engravingIdInput && engravingIdInput.value) {
						formData.append('items[1][id]', engravingIdInput.value);
						formData.append('items[1][quantity]', 1);

						let engravingTitle = selectedRadio.closest('.radio-box').textContent.trim();
						formData.append('items[0][properties][Angraving]', 'Yes');

						const hasText = this.textInput && this.textInput.value;
						const hasImage = this.fileInput && this.fileInput.files.length > 0;

						let engravingOption = '';
						if (hasText && hasImage) {
							engravingOption = 'Text & Image';
						} else if (hasText) {
							engravingOption = 'Text';
						} else if (hasImage) {
							engravingOption = 'Image';
						}
						if (engravingOption) {
							formData.append('items[0][properties][option]', engravingOption);
						}

						if (hasText) {
							formData.append('items[0][properties][Text]', this.textInput.value);
						}

						if (hasImage) {
							if (this.fileInput.files.length === 1) {
								formData.append('items[0][properties][Image]', this.fileInput.files[0]);
							} else {
								Array.from(this.fileInput.files).forEach((file, index) => {
									formData.append(`items[0][properties][Image ${index + 1}]`, file);
								});
							}
						}
						formData.append('items[0][properties][Type]', engravingTitle);

					} else {
						throw new Error("Engraving option missing");
					}
					if (this.isInProduction(mainIdInput.value)) formData.append('items[0][properties][_in_production]', '1');
					configBody = formData;
				} else {
					configBody = new FormData(this.form);
					if (this.isInProduction(configBody.get('id'))) configBody.append('properties[_in_production]', '1');
				}

				const config = {
					method: 'POST',
					headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
					body: configBody
				};

				const fetchUrl = routes.cart_add_url.includes('.js') ? routes.cart_add_url : `${routes.cart_add_url}.js`;
				const response = await fetch(fetchUrl, config);
				const data = await response.json();

				console.log(data);

				if (data.status) {
					this.errorMessage(data);
					return;
				}
				this.success();

			} catch (error) {
				console.error('Add to cart error:', error);
				this.toggleLoadingState(false);
				this.showCustomError(error.message);
			} finally {
				if (!document.querySelector('.engraving-popup.active')) {
					this.toggleLoadingState(false);
				}
			}
		}

		toggleLoadingState(isLoading) {
			this.addButtons?.forEach(button => {
				button.classList.toggle('loading', isLoading);
			});
		}

		errorMessage(resp) {
			console.log('Error:', resp);
			this.clearErrorMessage();
			let msg = resp.description || resp.message;
			if (msg && msg.includes('All')) msg = 'Product is sold out or unavailable';
			this.showCustomError(msg);
		}

		success() {
			this.clearErrorMessage();
			this.closeActivePopup();
			this.toggleLoadingState(false);
			if (typeof updateCartPopup === 'function') updateCartPopup();
			if (typeof updateCartCount === 'function') updateCartCount();
			this.openCartPopup();
		}

		openCartPopup() {
			if (window.jQuery) {
				$(".cart-drawer, .cart-overlay").addClass("open");
				if (typeof updateCartState === 'function') updateCartState();
			} else {
				document.querySelector('.cart-drawer')?.classList.add('open');
				document.querySelector('.cart-overlay')?.classList.add('open');
			}
		}

		closeActivePopup() {
			const activePopup = this.closest('.popup-content');
			if (activePopup) {
				if (typeof _functions !== 'undefined' && typeof _functions.closePopup === 'function') {
					_functions.closePopup();
				} else if (typeof closePopup === 'function') {
					closePopup();
				} else {
					activePopup.classList.remove('active');
					document.querySelector('.popup-wrapper')?.classList.remove('active');
					if (window.jQuery) $('.popup-wrapper, .popup-content').removeClass('active');
				}
			}
		}
	});
}